export const modalConstants = {
    MODAL_BAGIC: 'MODAL_BAGIC',
    MODAL_CLEAR: 'MODAL_CLEAR'
}
